import config from 'config'
import {NOTIFICATION_TYPES} from 'const/notifications'
import {getLang} from 'utils/stringUtils'
import {getDefaultConfig} from 'theme/brands/commonHelper'
import {FOOTER_LOGO_TYPES} from 'const/logos'

const getSpecificOrDefault = (specificValue, defaultValue) =>
  getLang(window.location.search) === 'fr' ? specificValue : defaultValue

const NORMAL_FONT = "'Baton Turbo Regular', Helvetica, Arial, sans-serif"
const BOOK_FONT = "'Baton Turbo Book', Helvetica, Arial, sans-serif"
const BOLD_FONT = "'Baton Turbo Heavy', Helvetica, Arial, sans-serif"

export default {
  brand: {
    name: null, // to be extended after merge
    url: null, // to be extended after merge
    favicon: '',
    fontColor: '#323232',
  },
  config: {
    ...getDefaultConfig(),
  },
  fontConfig: {
    custom: {
      urls: [`${config.url}/fonts/twentymin/index.css`],
    },
  },
  font: {
    family: NORMAL_FONT,
    fontWeight: 'normal',
    boldFamily: BOLD_FONT,
    boldFontWeight: 'bold',
    size: '14px',
    height: '20px',
    mobile: {
      size: '16px',
      height: '24px',
    },
    portrait: {
      size: '16px',
      height: '24px',
    },
    color: {
      dark: '#1A1A1A',
      light: '#FFFFFF',
    },
  },
  secondaryFont: {
    size: '16px',
    height: '24px',
    mobile: {
      size: '16px',
      height: '24px',
    },
    portrait: {
      size: '16px',
      height: '24px',
    },
  },
  title: {
    family: BOLD_FONT,
    size: '28px',
    height: '32px',
    mobile: {
      size: '28px',
      height: '32px',
    },
    portrait: {
      size: '42px',
      height: '46px',
    },
    weight: '600',
  },
  ringierBanner: {
    benefitsIcon: `${config.url}/assets/SI-icon-check-banner.svg`,
    linkColor: '#1A1A1A',
    linkHoverColor: '#1A1A1A',
    linkFontSize: '14px',
    padding: '20px',
    benefitMessageColor: '#1A1A1A',
    backgroundColor: '#EDF4FF',
    fontSize: '14px',
    lineHeight: '20px',
    iconWidth: '24px',
    iconHeight: '24px',
    borderRadius: '4px',
    landscape: {
      fontSize: '16px',
      titleFontSize: '18px',
    },
    titleFontWeight: 'bold',
    titleFontFamily: BOLD_FONT,
    onelogTitle: {
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '20px',
      color: '#000000',
      fontFamily: BOLD_FONT,
      margin: '0 0 20px 0',
    },
    onelogSection: {
      padding: '40px 0 0 0',
      borderTop: '1px solid #888888',
    },
  },
  otherBrandsLogos: [], // to be extended after merge
  note: {
    lightColor: '#A3A3A3',
    family: BOLD_FONT,
    lightFamily: NORMAL_FONT,
    fontSize: '18px',
    fontWeight: '700',
    lightFontWeight: '400',
  },
  notification: {
    family: '',
    success: '#0D7780',
    error: '#D0061C',
    pageError: '#D0061C',
    warning: '#C92AFF',
    info: '#0D2880',
    icon: {
      width: '24px',
      height: '24px',
      mobile: {
        width: '32px',
        height: '32px',
      },
    },
    pageMessage: {
      size: '16px',
      height: '24px',
      colorFunc: type => {
        switch (type) {
          case NOTIFICATION_TYPES.success:
            return '#1A1A1A'
          case NOTIFICATION_TYPES.warning:
          case NOTIFICATION_TYPES.info:
          case NOTIFICATION_TYPES.error:
          default:
            return '#FFFFFF'
        }
      },
    },
  },
  buttons: {
    height: '50px',
    primary: {
      border: 0,
      color: '#FFFFFF',
      background: '#0D2880',
      hoverBorder: 0,
      hoverBackground: '#0D2880',
      focusBorder: '2px solid #2659FF',
      focusBackground: '#0D2880',
      activeBorder: 0,
      activeBackground: '#0D2880',
      isAnimated: true,
    },
    secondary: {
      border: '1px solid #07184D',
      color: '#0D2880',
      background: '#FFFFFF',
      hoverBorder: '2px solid #0D2880',
      hoverColor: '#0D2880',
      hoverBackground: '#FFFFFF',
      focusBorder: '2px solid #2659FF',
      focusBackground: '#FFFFFF',
      activeBorder: '2px solid #0D2880',
      activeColor: '#0D2880',
      activeBackground: '#FFFFFF',
      dotsColor: '#0D2880',
    },
    disabled: {
      border: 0,
      color: '#A3A3A3',
      background: '#D8D8D8',
      hoverBorder: 0,
      hoverBackground: '#D8D8D8',
      activeBorder: 0,
      activeBackground: '#D8D8D8',
    },
    swiss: {
      border: '1px solid #0D2880',
      color: '#0D2880',
      background: '#FFFFFF',
      hoverBorder: '2px solid #0D2880',
      hoverBackground: '#FFFFFF',
      focusBorder: '2px solid #2659FF',
      focusBackground: '#FFFFFF',
      activeBorder: '1px solid #0D2880',
      activeBackground: '#FFFFFF',
      icon: 'swiss_id_rot.png',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
      textStyles: {
        weight: 300,
        family: BOOK_FONT,
      },
      isAnimated: false,
      full: true,
    },
    facebook: {
      border: '1px solid #0D2880',
      color: '#0D2880',
      background: '#FFFFFF',
      hoverBorder: '2px solid #0D2880',
      hoverBackground: '#FFFFFF',
      focusBorder: '2px solid #2659FF',
      focusBackground: '#FFFFFF',
      activeBorder: '1px solid #0D2880',
      activeBackground: '#FFFFFF',
      icon: 'icon-facebook-24x24.svg',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
      textStyles: {
        weight: 300,
        family: NORMAL_FONT,
      },
      isAnimated: false,
      full: true,
    },
    apple: {
      border: '1px solid #0D2880',
      color: '#0D2880',
      background: '#FFFFFF',
      hoverBorder: '2px solid #0D2880',
      hoverBackground: '#FFFFFF',
      focusBorder: '2px solid #2659FF',
      focusBackground: '#FFFFFF',
      activeBorder: '1px solid #0D2880',
      activeBackground: '#FFFFFF',
      icon: 'logo-apple-black.svg',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
      textStyles: {
        weight: 300,
        family: NORMAL_FONT,
      },
      isAnimated: false,
      full: true,
    },
    google: {
      border: '1px solid #0D2880',
      color: '#0D2880',
      background: '#FFFFFF',
      hoverBorder: '2px solid #0D2880',
      hoverBackground: '#FFFFFF',
      focusBorder: '2px solid #2659FF',
      focusBackground: '#FFFFFF',
      activeBorder: '1px solid #0D2880',
      activeBackground: '#FFFFFF',
      icon: 'icon-google-24x24.svg',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
      textStyles: {
        weight: 300,
        family: NORMAL_FONT,
      },
      isAnimated: false,
      full: true,
    },
    touchId: {
      border: 0,
      color: '#FFFFFF',
      background: '#0D2880',
      hoverBorder: 0,
      hoverBackground: '#0D2880',
      focusBorder: '2px solid #2659FF',
      focusBackground: '#0D2880',
      activeBorder: 0,
      activeBackground: '#0D2880',
      isAnimated: true,
      full: true,
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
    },
    faceId: {
      border: 0,
      color: '#FFFFFF',
      background: '#0D2880',
      hoverBorder: 0,
      hoverBackground: '#0D2880',
      focusBorder: '2px solid #2659FF',
      focusBackground: '#0D2880',
      activeBorder: 0,
      activeBackground: '#0D2880',
      isAnimated: true,
      full: true,
      icon: 'icon-faceid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
    },
    anyId: {
      border: 0,
      color: '#FFFFFF',
      background: '#0D2880',
      hoverBorder: 0,
      hoverBackground: '#0D2880',
      focusBorder: '2px solid #2659FF',
      focusBackground: '#0D2880',
      activeBorder: 0,
      activeBackground: '#0D2880',
      isAnimated: true,
      full: true,
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
    },
    icon: {
      height: '24px',
      width: '24px',
    },
    text: {
      family: BOOK_FONT,
      boldFamily: BOLD_FONT,
      color: '#004056',
      size: '16px',
    },
    border: {
      radius: '4px',
    },
    linkOnSecondLine: true,
    dotsColor: '#FFFFFF',
  },
  link: {
    default: '#0D2880',
    hoverColor: '#1A1A1A',
    infoHoverColor: '#0D2880',
    secondary: '#1A1A1A',
    secondaryHover: '#0D2880',
    isAgreementsLink: true,
    agreement: '#A3A3A3',
    textDecorationHover: 'underline',
  },
  logisterSection: {
    registerMarginTop: '20px',
    registerWeight: 300,
    subheaderBorderTop: '1px solid #d9d9d9',
    subheaderPadding: '12px 20px',
    subheaderFamily: BOLD_FONT,
    subheaderFontSize: '14px',
    subheaderLineHeight: '20px',
    subheaderTitleColor: '#1A1A1A',
    subheaderTitleMargin: '0 0 4px 0',
    subheaderLinkColor: '#1A1A1A',
    subheaderLinkHoverColor: '#1A1A1A',
    subheaderBackgroundColor: '#F6F6F6',
    noteColor: '#A3A3A3',
    noteFontSize: {
      default: '14px',
      portrait: '14px',
    },
    title: {
      textChangeBreakpoint: 'mobile',
      fontSize: {
        smallMobile: '24px',
        mobile: '24px',
        portrait: '24px',
        landscape: getSpecificOrDefault('32px', '34px'),
        desktop: getSpecificOrDefault('32px', '34px'),
      },
      lineHeight: {
        smallMobile: '30px',
        mobile: '28px',
        portrait: '28px',
        landscape: '40px',
        desktop: '40px',
      },
    },
    subtitle: {
      color: '#1A1A1A',
      fontSize: {
        default: '14px',
        portrait: '14px',
      },
      lineHeight: '24px',
      margin: '-12px 0 12px',
      link: {
        color: '#1A1A1A',
        hoverColor: '#1A1A1A',
      },
    },
  },
  form: {
    border: '',
    background: '#F7F7F7',
    fieldBackground: '',
    padding: '0 0 20px 0',
    sectionViewBackground: '#f8f8f8',
    marginBottom: '0px',
    loginSubmitMarginTop: '0',
    note: {
      fontSize: '18px',
    },
  },
  logisterForm: {
    border: '',
    background: '',
    padding: '',
    submitButton: 'primary',
    forgetLinkFloat: 'right',
  },
  loginForm: {
    forgetLink: {
      wrapper: {
        defaultMarginBottom: '20px',
        errorMarginBottom: '22px',
      },
      link: {
        fontSize: '14px',
        marginTop: '6px',
      },
    },
  },
  registerPage: {
    backLinkMargin: {
      default: '0 0 12px',
      portrait: '0 0 12px',
    },
    titleMargin: {
      default: '0 0 20px',
      portrait: '0 0 20px',
    },
    submitButtonMarginTop: 0,
  },
  emailVerifyPage: {
    linkMarginBottom: '10px',
    note: {
      fontFamily: BOLD_FONT,
    },
  },
  field: {
    error: {
      background: 'inherit',
      fontColor: '#D0061C',
      size: '14px',
      height: '20px',
      padding: '4px 20px 0',
      margin: '0 -20px',
    },
    label: {
      color: '#6B78A0',
      disabledColor: 'rgba(31,31,31,0.6)',
      family: BOOK_FONT,
      boldFamily: BOLD_FONT,
      fontSize: '14px',
      fontHeight: '20px',
      fontWeight: '300',
    },
    optional: {
      color: '#A3A3A3',
    },
    edging: {
      backgroundColor: '#F7F7F7',
    },
  },
  input: {
    fontFamily: BOOK_FONT,
    color: '#0D2880',
    background: '#FFFFFF',
    errorBackground: '#FFFFFF',
    border: 'none',
    borderBottom: '1px solid #6B78A0',
    focusBorder: 'none',
    hoverBorderBottom: '1px solid #6B78A0',
    focusBorderBottom: '1px solid #2659FF',
    errorBorderBottom: '1px solid #D0061C',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    height: '50px',
    padding: '12px 0',
    email: {
      color: '#888888',
      backgroundColor: '#F6F6F6',
      border: '0',
      borderRadius: '4px',
      button: {
        height: '28px',
        right: '12px',
        backgroundColor: '#FFFFFF',
        width: '70px',
        color: '#0D2880',
        fontFamily: NORMAL_FONT,
        fontSize: '14px',
        textDecoration: 'none',
        border: '1px solid #0D2880',
        borderRight: '1px solid #0D2880',
        borderRadius: '4px',
        hoverColor: '#0D2880',
        hoverBorder: '1px solid #0D2880',
        hoverBorderRight: '1px solid #0D2880',
        hoverFamily: BOLD_FONT,
      },
    },
    password: {
      color: '#0D2880',
      hoverColor: '#1A1A1A',
      size: '14px',
      height: '20px',
      top: '12px',
    },
    loading: {
      top: '7px',
    },
    placeholder: {
      color: '#A3A3A3',
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  textarea: {
    height: '96px',
  },
  checkbox: {
    icon: {
      height: '16px',
      width: '16px',
      top: '3px',
      right: '12px',
      image: '20M-form-checkbox.svg',
      checkedImage: '20M-form-checkbox-checked.svg',
      hoverImage: '20M-form-checkbox-hover.svg',
      errorImage: '20M-form-checkbox-error.svg',
      disabledImage: 'SI-form-checkbox-inactive.svg', // TODO update
    },
    errorMargin: '',
    padding: '16px 20px',
    labelFontHeight: '24px',
    labelColor: '#1A1A1A',
    group: {
      label: {
        marginBottom: '8px',
        padding: '0',
        backgroundColor: '',
      },
      marginBottom: '20px',
      padding: '0 20px',
      backgroundColor: '#F9F9F9',
      fontWeight: '400',
      fontSize: '16px',
      note: {
        fontWeight: '300',
        fontSize: '14px',
        marginLeft: '28px',
        color: '#1A1A1A',
      },
    },
    errorPadding: '4px 20px 0',
  },
  select: {
    fontFamily: BOOK_FONT,
    icon: {
      width: '16px',
      height: '16px',
      image: '20M-form-arrow-down.svg',
      focusImage: '20M-form-arrow-down.svg',
      alt_image: '20M-form-arrow-down.svg',
    },
    menu: {
      border: '1px solid #E1E8F1',
      isCheckIconVisible: false,
      checkIcon: 'NRJ-check-form-grey.svg',
      color: '#0D2880',
      option: {
        fontFamily: BOOK_FONT,
        padding: '4px 20px',
        focusBorder: '0',
        focusBackground: '#EDF4FF',
        focusColor: '#0D2880',
        selectedFontFamily: BOLD_FONT,
      },
      placeholder: {
        color: '#A3A3A3',
      },
      singleValue: {
        color: '#0D2880',
      },
    },
    dropdownIndicator: {
      padding: '0',
    },
  },
  radio: {
    icon: {
      width: '16px',
      height: '16px',
      image: 'SI-form-radio.svg',
      checkedImage: '20M-form-radio-active.svg',
      hoverImage: '20M-form-radio-hover.svg',
      errorImage: '20M-form-radio-error.svg',
      disabledImage: '20M-form-radio.svg',
    },
    errorMargin: '0 -20px 0px',
    labelFontHeight: '24px',
    labelMarginBottom: '8px',
    color: '#0D2880',
  },
  errorPage: {
    font: {
      height: '18px',
      portrait: {
        height: '30px',
      },
    },
  },
  inputNote: {color: '#A3A3A3', size: '14px', height: '20px', marginTop: '4px'},
  separator: {
    background: '#888888',
    color: '#888888',
    height: '1px',
    fontSize: '14px',
    lineHeight: '16px',
    portraitMargin: '24px 0 28px 0',
    transform: 'none',
  },
  tab: {
    fontSize: '18px',
    desktop: {focusBorder: 'solid 4px #1A1A1A', bottomMargin: '-4px', height: '80px'},
    mobile: {icon: {border: 'solid 2px #ACACAC', width: '14px', height: '14px', color: '#1A1A1A'}},
  },
  shell: {
    header: {
      color: '#000',
      backgroundColor: '#FFF',
      height: {
        default: '80px',
        onScroll: '56px',
        withEmail: '102px',
      },
      poweredLogo: {
        src: 'logo-onelog-poweredby-black.png',
      },
      logo: {
        height: {
          default: '54px',
          small: '40px',
          onScroll: '40px',
        },
      },
      languageSwitcher: {
        color: '#000',
        activeColor: '#0d2880',
        backgroundColor: '#FFFFFF',
        menu: {
          fontSize: '16px',
          lineHeight: '22px',
          color: '#000',
          hoverBackgroundColor: '#CFD3E3',
        },
      },
      menu: {
        default: {
          color: '#000',
          fontSize: '20px',
        },
        active: {
          color: '#FFFFFF',
          backgroundColor: '#0d2880',
          hoverBackgroundColor: '#1A1A1A',
          selectedBackgroundColor: '#000',
          separatorColor: '#2C3B47',
        },
      },
      border: {
        width: '0 0 1px 0',
        color: '#DFE6F0',
        style: 'solid',
      },
    },
    footer: {
      tenants: {
        logoColor: FOOTER_LOGO_TYPES.black,
        color: '#1A1A1A',
        hoverColor: '#0D2880',
        backgroundColor: '#EDF4FF',
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: '#cdd5db',
      },
      copyright: {
        color: '#a3a3a3',
        hoverColor: '#0d2880',
        backgroundColor: '#FFF',
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: '#cdd5db',
      },
    },
  },
  consent: {
    subtitle: {
      marginBottom: '8px',
    },
    checkbox: {
      marginBottom: '20px',
      paddingBottom: '',
    },
    agreements: {
      color: '#A3A3A3',
    },
  },
  mobileNumber: {
    label: {
      marginBottom: '20px',
    },
    subtitle: {
      marginTop: '8px',
      color: '#1A1A1A',
    },
    select: {
      padding: '8px 0px',
      backgroundColor: '#F7F7F7',
      borderRight: '1px solid #6B78A0',
      hoverBorderRight: '1px solid #6B78A0',
      focusBorderRight: '1px solid #6B78A0',
      errorBorderRight: '1px solid #6B78A0',
    },
    selectIcon: {
      padding: '0px 12px',
    },
    input: {
      backgroundColor: '#F7F7F7',
      errorBackgroundColor: '#F7F7F7',
      padding: '8px 12px',
    },
    code: {
      letterSpacing: '7px',
      paddingLeft: {
        normal: 'calc(50% - 50px)',
        error: 'calc(50% - 51px)',
      },
      underline: {
        left: 'calc(50% - 20px)',
        top: 'calc(50% - 7px)',
      },
    },
    questionLabel: {
      family: BOLD_FONT,
      color: '#1A1A1A',
    },
    link: {
      fontSize: '14px',
      lineHeight: '20px',
      fontFamily: BOOK_FONT,
    },
    verifiedLabel: {
      color: '#1A1A1A',
    },
  },
  address: {
    padding: '20px 20px 0px 20px',
    inputBackgroundColor: '#F7F7F7',
    formFieldMarginBottom: '',
    checkboxPadding: '0px 0px 20px 0px',
    link: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    control: {
      fontSize: '16px',
      fontFamily: BOOK_FONT,
      lineHeight: '24px',
    },
  },
  mfa: {
    inputPadding: '12px',
  },
  languageSwitcher: {
    menuColor: '#0D2880',
    fontRegular: NORMAL_FONT,
    fontSemiBold: BOOK_FONT,
    fontBold: BOLD_FONT,
    menuIcon: '20M-form-arrow-down.svg',
    menuOnHover: `font-family: ${BOLD_FONT}`,
    listItemActiveColor: '#0D2880',
    listItemDefaultColor: '#0D2880',
    listItemHoverColor: '#EDF4FF',
    listItemLineHeight: '36px',
    listItemFontSize: '16px',

    profileMenuIcon: 'OL-icon-arrow-down-grey.svg',
    profileMenuColor: '#3C5162',
    profileMenuFont: '',
  },
}
